import { ChevronDown } from "lucide-react";
import MetricItem from "./MetricItem";
import CommonAvatar from "@/shared/components/ui/Avatar/CommonAvatar";
import { renderEmailContent } from "@/shared/utils/markdownUtils";
import DOMPurify from "dompurify";
import { sanitizeCompanyLogoUrl } from "@/features/dashboard/utils/accountsDashboardUtils";

const ProfileSection = ({ accordionOpen, toggleAccordion, profileData }) => {
  return (
    <div className="rounded-lg py-7 pr-4 pl-5 shadow mx-[1px] mb-6">
      <div className="w-full flex">
        <div className="flex ">
          <div className="w-1/4 flex-shrink-0 flex flex-col gap-5 items-center pr-5">
            <CommonAvatar
              imageUrl={profileData?.image}
              name={profileData?.name}
              className="w-20 h-20 rounded-full text-2xl"
            />
            {/* name and company name */}
            <div className="flex flex-col text-center gap-1.5">
              <h2 className="text-lg font-semibold text-gray-800">
                {profileData?.name}
              </h2>
              <p className="text-sm font-medium text-gray-800">
                {profileData?.position || "N/A"}
              </p>
              <div className="flex gap-1.5 items-center justify-center">
                <CommonAvatar
                  imageUrl={sanitizeCompanyLogoUrl(profileData?.company_logo)}
                  name={profileData?.company}
                  className="w-6 h-6 rounded-full"
                  textClassName="text-[10px]"
                />
                <p className=" text-gray-500 text-xs font-medium">
                  {profileData?.company}
                </p>
              </div>
            </div>
          </div>

          {/* Info section */}
          <div className="flex justify-between relative w-full">
            <div className="w-3/4 flex-grow px-5 flex flex-col gap-5">
              {/* Metrics */}
              <div className="flex gap-5 items-center">
                <MetricItem
                  title="Buying Authority"
                  value={profileData?.metrics?.[0]?.value}
                  bgcolor="bg-green-50"
                  reason={profileData?.metrics?.[0]?.reason}
                  txtcolor="text-green-600"
                />
                <div className="w-[1.2px] h-full bg-[#EFF0F4]" />
                <MetricItem
                  title="Buying Intent"
                  value={profileData?.metrics?.[1]?.value}
                  bgcolor="bg-gray-100"
                  txtcolor="text-gray-600"
                  reason={profileData?.metrics?.[1]?.reason}
                />
                <div className="w-[1.5px] h-full bg-[#EFF0F4]" />
                <MetricItem
                  title="Sales Score"
                  value={profileData?.metrics?.[2]?.value}
                  bgcolor="bg-gray-100"
                  txtcolor="text-gray-600"
                  reason={profileData?.metrics?.[2]?.reason}
                />
              </div>
              <div className="flex flex-col gap-1">
                <h5 className="text-sm text-gray-800 font-semibold">
                  Relevance & Recommendations
                </h5>
                <div
                  className="text-gray-500 text-xs"
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(
                      renderEmailContent(profileData?.recommendations),
                    ),
                  }}
                />
              </div>

              <div className="flex gap-5">
                {profileData?.actions?.map((action, index) => (
                  <p
                    className="text-xs font-medium text-secondary cursor-pointer hover:text-gray-800"
                    key={index}
                  >
                    {action}
                  </p>
                ))}
              </div>

              {/* Expandable Content */}
              <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${
                  accordionOpen
                    ? "max-h-96 opacity-100 visible"
                    : "max-h-0 opacity-0 invisible"
                }`}
              >
                <div className="flex flex-col  gap-6">
                  <div className="flex flex-col gap-1">
                    <h5 className="text-sm text-gray-800 font-semibold">
                      Work Role
                    </h5>
                    <div
                      className="text-gray-500 text-xs"
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                          renderEmailContent(profileData?.work_role),
                        ),
                      }}
                    />
                  </div>
                  <div className="flex flex-col gap-1">
                    <h5 className="text-sm text-gray-800 font-semibold">
                      Buying Behaviour & Interests
                    </h5>
                    <div
                      className="text-gray-500 text-xs"
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                          renderEmailContent(profileData?.buyingBehaviour),
                        ),
                      }}
                    />
                  </div>

                  <div className="flex flex-col gap-1">
                    <h5 className="text-sm text-gray-800 font-semibold">
                      Intent Activity with Your Company
                    </h5>
                    <div
                      className="text-gray-500 text-xs"
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(
                          renderEmailContent(profileData?.buyingIntent),
                        ),
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* chevron */}
            <button
              className="text-gray-400 hover:text-gray-600 flex items-start"
              onClick={toggleAccordion}
            >
              <ChevronDown
                size={20}
                color="#181D27"
                className={`transition-transform duration-300 ${
                  accordionOpen ? "rotate-180" : ""
                }`}
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileSection;
